import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DeepDiveData } from "src/pages/Studies/models/interfaces";

const initialState: DeepDiveData = {
	collaborators: [],
	insight_details: { study_id: "" }, // Initially only contains study_id
	study_name: "",
	study_tags: [],
	user_access_type: "",
	selectedQuesId: null,
	blurOnOpen: false,
};

const deepDiveInsightSlice = createSlice({
	name: "deepdiveData",
	initialState: {
		deepDiveData: initialState,
	},
	reducers: {
		setDeepDiveData: (state, action: PayloadAction<any>) => {
			state.deepDiveData = action.payload;
		},
		setDeepDiveAccessType: (state, action: PayloadAction<string>) => {
			state.deepDiveData.user_access_type = action.payload;
		},
		setSelectedQuesId: (state, action: PayloadAction<number | null>) => {
			state.deepDiveData.selectedQuesId = action.payload;
		},
		setBlurOnOpen: (state, action: PayloadAction<boolean>) => {
			state.deepDiveData.blurOnOpen = action.payload;
		},
		resetDeepDiveData: (state) => {
			state.deepDiveData = initialState;
		},
	},
});

export const { setDeepDiveData, setDeepDiveAccessType, setSelectedQuesId, setBlurOnOpen, resetDeepDiveData } = deepDiveInsightSlice.actions;

export default deepDiveInsightSlice.reducer;
